import React, { Component } from "react";

class JackpotElements extends Component {
  render() {
    const { background, elements } = this.props;
    return (
      <div style={background}>
        {elements.map((elem, i) => {
          return (
            <div key={`element-${i}`} style={elem}>
              {elem.caption &&
                elem.caption !== "" &&
                (elem.captionPosition === "top" ||
                  elem.captionPosition === "left") && (
                  <div
                    style={{
                      display:
                        elem.captionPosition === "left"
                          ? "inline-block"
                          : "block",
                      fontSize: "0.6em",
                      lineHeight: "0.6em",
                      verticalAlign: "middle",
                      margin:
                        elem.captionPosition === "left"
                          ? "0em 0.4em"
                          : "0.2em 0em"
                    }}
                  >
                    {elem.caption}
                  </div>
                )}
              {elem.content}
              {elem.caption &&
                elem.caption !== "" &&
                (elem.captionPosition === "bottom" ||
                  elem.captionPosition === "right") && (
                  <div
                    style={{
                      display:
                        elem.captionPosition === "right"
                          ? "inline-block"
                          : "block",
                      fontSize: "0.6em",
                      lineHeight: "0.6em",
                      verticalAlign: "middle",
                      margin:
                        elem.captionPosition === "right"
                          ? "0em 0.4em"
                          : "0.2em 0em"
                    }}
                  >
                    {elem.caption}
                  </div>
                )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default JackpotElements;
